// @ts-ignore

import { Carrier } from 'app/pages/ToursPage/types';
import { compareAsc, differenceInBusinessDays, parseISO } from 'date-fns';
import { Tour } from 'app/models/Tour';
import { Destination } from 'app/models/Destination';
import {
  getTypeNameWithType,
  ProductionPiece,
} from 'app/models/ProductionPiece';
import { Workstation } from 'app/containers/OrderDetails/types';

export function findTour(
  date: Date,
  carrier: Carrier,
  destination: Destination,
  tours: Tour[],
): Tour | undefined {
  for (const tour of tours) {
    if (
      tour.carrier?.id === carrier.id &&
      tour.destination?.aggregatedDestinationName ===
        destination.aggregatedDestinationName
    ) {
      const tourDate = parseISO(tour.date);
      if (date.setHours(0, 0, 0, 0) === tourDate.setHours(0, 0, 0, 0)) {
        return tour;
      }
    }
  }

  return undefined;
}

export function findDirectTour(tours: Tour[]): Tour | undefined {
  for (const tour of tours) {
    if (tour.destination?.name === 'Direct') {
      return tour;
    }
  }
  return undefined;
}

export function findTourShop(
  destination: Destination,
  tours: Tour[],
): Tour | undefined {
  let closedTour: Tour | undefined = undefined;
  for (const tour of tours) {
    if (
      tour.destination?.id === destination.id &&
      differenceInBusinessDays(parseISO(tour.date), new Date()) > 3
    ) {
      if (
        closedTour === undefined ||
        compareAsc(parseISO(closedTour.date), parseISO(tour.date)) > 0
      ) {
        closedTour = tour;
      }
    }
  }

  return closedTour;
}

export const pieceRef = (ref: string, type?: string, description?: string) => {
  let partDescription = '';
  if (description && description.includes('+ trou')) {
    partDescription = ` + trou${description.split('+ trou')[1]}`;
  }
  if (ref.startsWith('*custom')) {
    const typeOfPiece = getTypeNameWithType(type ?? '');
    switch (typeOfPiece) {
      case 'door':
        return `Porte personnalisée`;
      case 'pane':
        return `Panneau personnalisé`;
      case 'plate':
        return `Plateau personnalisé`;
      case 'cross piece':
        return `Traverse personnalisée`;
      case 'feet cabinet':
        return `Tasseau de pied personnalisé`;
      case 'batten':
        return `Tasseau personnalisé`;
      case 'rod':
        return `Tringle personnalisée`;
      case 'desk tablet':
        return 'Tablette de bureau personnalisée' + partDescription;
      case 'intermediate':
        return 'TI personnalisée';
      case 'tablet':
        return 'Tablette personnalisée';
    }

    return `Pièce personnalisée`;
  }
  if (ref[0] === '*') {
    return `Personnalisé (${ref.slice(1, ref.indexOf('-'))})`;
  }

  return ref.replace(/ *\[[^\]]*]/, '') + partDescription;
};

export const pieceRefWithProductionPiece = (
  piece: ProductionPiece,
  cutting = false,
) => {
  if (piece.product && piece.product.uniqueProduct) return 'SPECIAL';
  if (piece.station === Workstation.WoodworkSpecial && cutting) {
    return piece.description ? piece.description[0] : '';
  }

  return pieceRef(
    piece.reference,
    piece.type,
    piece.description ? piece.description[0] : '',
  );
};
